import { render, staticRenderFns } from "./ShelfAddNew.vue?vue&type=template&id=285189d7&"
import script from "./ShelfAddNew.vue?vue&type=script&lang=js&"
export * from "./ShelfAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports